import { render, staticRenderFns } from "./WxBind.vue?vue&type=template&id=a76d14e8&scoped=true"
import script from "./WxBind.vue?vue&type=script&lang=js"
export * from "./WxBind.vue?vue&type=script&lang=js"
import style0 from "./WxBind.vue?vue&type=style&index=0&id=a76d14e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76d14e8",
  null
  
)

export default component.exports